// Activities/Broadcast
export const activitiesEndpoint = '/api/v1/homework/activities'
export const broadcastEndpoint = '/api/v1/broadcast'

export const studentHomeworkTasksUrl = ({
  lessonId,
  classId,
  teacherId,
  homeworkId,
  filter,
}) =>
  `/students/homework/tasks/homework_tasks.json?lesson_id=${lessonId}${
    classId ? `&class_id=${classId}` : ''
  }&teacher_id=${teacherId}&homework_id=${homeworkId}&filter=${filter}`
export const feedbackUrl = '/api/v1/feedbacks'
export const taskResultsUrl = ({ homeworkId, taskId, studentId, include }) =>
  `/api/v1/homework_tasks?by_homework=${homeworkId}${
    taskId ? `&by_task=${taskId}` : ''
  }${
    studentId ? `&by_student=${studentId}` : ''
  }&by_state[]=active&by_state[]=expired&by_completion_state[]=complete${
    include ? `&include[]=${include}` : ''
  }`
export const activitiesUrl = hwtId =>
  `/api/v1/homework_tasks/${hwtId}/homework_activities`
export const activityUrl = activityId =>
  `/api/v1/homework/activities/${activityId}`

export const placementsUrl = ({
  classId,
  includes,
  page,
  sort,
  search,
  filter,
  stdType,
  limit,
}) =>
  `/api/v1/placements?${
    classId ? `by_class=${classId}` : ''
  }&include[]=${includes}&include[]=feedbacks_count&include[]=assignments_count&page=${page}&sort=${sort}&search=${search}${
    filter ? `&filter=${filter}` : ''
  }${stdType ? `&student_type=${stdType}` : ''}${
    limit ? `&limit=${limit}` : ''
  }`

export const resendInvitationUrl = ({ classId, invitationId }) =>
  `/yumi/classes/${classId}/invitations/${invitationId}/resend`
export const cancelInvitationUrl = ({ classId, invitationId }) =>
  `/yumi/classes/${classId}/invitations/${invitationId}`
export const removeStudentUrl = '/yumi/classes/remove_student'
export const homeworksUrl = ({
  homeworkId,
  classId,
  includes,
  page,
  studentId,
  teacherId,
  filter,
  search,
  sort,
}) =>
  `/api/v1/homeworks${
    homeworkId ? `/${homeworkId}` : ``
  }?include[]=${includes.join('&include[]=')}${
    classId ? `&by_class=${classId}` : ''
  }${page ? `&page=${page}` : ''}${
    studentId ? `&by_student=${studentId}` : ''
  }${teacherId ? `&by_teacher=${teacherId}` : ''}${
    filter ? `&filter=${filter}` : ''
  }${search ? `&search=${search}` : ''}${sort ? `&sort=${sort}` : ''}`
export const assignedTasksUrl = hwid =>
  `/api/v1/homeworks/${hwid}/assigned_tasks`
export const deleteStudentsUrl = `/yumi/classes/delete_students`
export const archiveStudentsUrl = `/yumi/classes/archive_students`
export const unarchiveStudentsUrl = `/yumi/classes/unarchive_students`

// Student Dashboard
export const sdTasksUrlKanbanClass = ({ classId, filter, page }) =>
  `/api/v3/students/classes/${classId}/contents?filter=${filter}&page=${page}`
// Legacy
export const sdTasksUrlIndividual = ({ version, studentId, filter, page }) =>
  `/api/${version}/students_dashboard/${studentId}?filter=${filter}&page=${page}`
export const sdFlashcardsLegacyClass = classId =>
  `/api/v1/students/shared_flashcard_sets?${
    classId ? `class_id=${classId}` : ''
  }`
export const sdTasksUrlLegacyClass = ({
  version,
  studentId,
  filter,
  page,
  classId,
}) =>
  `/api/${version}/students_dashboard/${studentId}?filter=${filter}&page=${page}${
    classId ? `&class_id=${classId}` : ''
  }`

// Kanban class-student
export const classStudentUrl = ({ classId, studentId, page }) =>
  `/api/v3/teachers/classes/${classId}/student_results?student_id=${studentId}${
    page ? `&page=${page}` : ''
  }`

export const createClassReportUrl = ({ classId, start, end }) =>
  `/api/v1/exports/classes?class_id=${classId}&start_at=${start}&end_at=${end}`
export const getClassReportUrl = classId => `/api/v1/exports/classes/${classId}`
export const createHomeworkReportUrl = `/api/v1/exports/homeworks`
export const getHomeworkReportUrl = exportId =>
  `/api/v1/exports/homeworks/${exportId}`
export const createTaskAssignmentUrl =
  '/api/v1/homework_task_assignments/assign'
export const taskAssignmentsSelectionUrl = ({
  entity,
  teacherId,
  lessonId,
  classId,
}) =>
  `/api/v1/homework_task_assignments/${entity}?teacher_id=${teacherId}&lesson_id=${lessonId}${
    classId ? `&class_id=${classId}` : ''
  }`
export const cancelAssignmentUrl = id =>
  `/api/v1/homeworks/${id}/cancel_assignment`
export const studentSignUp = '/students/sign_up'
export const studentCheckUsername = '/students/check_username'
export const studentCheckEmail = '/students/check_email'
export const studentSendEmailInvitation = id =>
  `/api/v3/teachers/classes/${id}/invitations`
export const studentUpdate = id => `/students/account/${id}`

export const classResetCode = id => `/yumi/classes/${id}/reset_code`
export const classesUrl = ({
  teacherId,
  sort,
  includes,
  page,
  search,
  classType,
}) =>
  `/api/v1/classes?by_teacher=${teacherId}${
    includes ? `&include[]=${includes}` : ''
  }&sort=${sort}&page=${page}${
    search ? `&search=${search}` : ''
  }&class_type=${classType}`
export const classUpdate = id => `/yumi/classes/${id}`
export const classCreate = `/yumi/classes`
export const classDelete = id => `/yumi/classes/${id}`
export const classArchiveUrl = '/api/v1/classes/archive_classes'
export const classUnarchiveUrl = '/api/v1/classes/unarchive_classes'
export const classDeleteUrl = '/api/v1/classes/delete_classes'
export const classCreateStudentAccount = id =>
  `/api/v3/teachers/classes/${id}/accounts`

export const feedActivitiesUrl = ({ classId, page }) =>
  `/api/v1/feed_activities?${
    classId ? `by_class=${classId}` : ''
  }&page=${page}&limit=15`

export const updateNotificationSettingsEndpoint =
  '/api/v1/users/update_notification_settings'
export const getNotificationSettingsEndpoint =
  '/api/v1/users/notification_settings'
export const updateNotificationsSettingsEndpoint =
  '/api/v1/email_preferences/update_notifications_settings'
export const attendanceUrl = ({ classId, from, to, sort }) =>
  `/api/v1/participation?by_class=${classId}&start_at=${from}&end_at=${to}&sort=${sort}`
export const createParticipationReportUrl = `/api/v1/exports/participation`
export const createActivitiesReportUrl = `/api/v1/exports/activities`
export const createAssignmentsReportUrl = `/api/v1/exports/assignments`
export const getParticipationReportUrl = exportId =>
  `/api/v1/exports/participation/${exportId}`
export const getActivitiesReportUrl = exportId =>
  `/api/v1/exports/activities/${exportId}`
export const getAssignmentsReportUrl = exportId =>
  `/api/v1/exports/assignments/${exportId}`
export const levelPreferenceUrl = '/api/v1/users/level_preference'
export const lessonRecommendations = classId =>
  `/api/v1/recommendations/lessons?class_id=${classId}`
